// Request headers
export enum RequestHeaders {
  Authorization = 'Authorization',
  Accept = 'Accept',
}

export default {
  MIN_DATE_RANGE: '1900-01-01',
  MAX_DATE_RANGE: '2100-12-31',
  USER_ROLES: {
    USER: 'user',
    ADMIN: 'admin',
  },
  AUTH_TOKENS: {
    ACCESS_TOKEN: 'accessToken',
    REFRESH_TOKEN: 'refreshToken',
  },
  SIDE_MENU_MAX_WIDTH: 25.6,
  DEBOUNCE_TIMEOUT: 500,
  BULK_COUNT: 1000,
  INITIAL_PAGE_NO: 1,
  INITIAL_ROWS_PER_PAGE: 10,
  INITIAL_USERS_COUNT: 10,
  LIMIT_TAGS: 2,
  INITIAL_SORT_ORDER: 'createdAt',
  UPLOAD_FILE_SIZE: 1024,
  INITIAL_DNC_SORT_ORDER: 'CREATE_DATE',
  INITIAL_STATE_TSR_SORT_ORDER: 'ID',
  INITIAL_SORT_DIRECTION: 'DESC',
  INITIAL_USERS_SORT_ORDER: 'id',
  INITIAL_USERS_SORT_DIRECTION: 'ASC',
  START_TIME: '00:00:00.000Z',
  END_TIME: '23:59:59.999Z',
  QUERY_PARAMS: {
    COMMON: {
      PAGE_NO: 'pageNo',
      PAGE_SIZE: 'pageSize',
      SEARCH: 'search',
      ORDER: 'order',
      LIST_TYPE: 'listType',
      DATE_START: 'dateStart',
      DATE_END: 'dateEnd',
      TYPE: 'type',
      NAME: 'name',
      DEFAULT: 'default',
      SORT_BY: {
        ASC: 'ASC',
        DESC: 'DESC',
      },
      DIRECTION: 'direction',
      TOKEN: 'token',
      REDIRECT_TO: 'redirectTo',
      GROUP_NAME: 'groupName',
      DISPLAY_TYPE: 'displayType',
    },
    USERS: {
      USER_ID: 'userId',
      USER_NAME: 'userName',
      MODULE: 'module',
      SORT_BY: {
        ID: 'id',
        FULL_NAME: 'fullName',
        EMAIL: 'email',
        ADMIN: 'admin',
      },
      HAS_USER_TPR: 'hasUserTpr',
      HAS_USER_LIVE_CONNECT: 'hasUserLiveConnect',
    },
    REPORT: {
      REPORT_TYPE: 'type',
      USER_IDS: 'userIds',
      SESSION_NAME: 'sessionName',
      SESSION_ID: 'sessionId',
      VOICE_PROVIDER: 'voiceProvider',
      CALL_STATUS: 'callStatus',
      DISPOSITION: 'disposition',
      SORT_BY: {
        SESSION_NAME: 'listName',
        SESSION_DATE: 'sessionDate',
        DURATION: 'duration',
        CALLS: 'calls',
        CONTACTED: 'contacted',
        DISCONNECTED: 'disconnected',
        NO_ANSWER: 'noAnswer',
        TOTAL_TIME: 'totalTime',
        START_DATE: 'startDate',
        SESSION_DURATION: 'duration',
        LAST_CALL: 'lastCall',
      },
    },
    DNC: {
      PHONE: 'phone',
    },
  },
  DNC_SORT: {
    PHONE: 'PHONE',
    REASON: 'REASON',
    CREATE_DATE: 'CREATE_DATE',
    LAST_UPDATE_DATE: 'LAST_UPDATE_DATE',
  },
  STATE_TSR: {
    STATE_TSR_SORT: 'STATE',
  },
  REGEX: {
    PHONE_NUMBER:
      /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s-]?[\0-9]{3}[\s-]?[0-9]{4}$/,
  },
  GLOBAL_MESSAGES: {
    GENERIC_ERROR_MESSAGE: 'GENERIC_ERROR_MESSAGE',
    GENERIC_SUCCESS_MESSAGE: 'GENERIC_SUCCESS_MESSAGE',
    ADD_SCRIPT: 'ADD_SCRIPT',
    AUTO_ADD_DEFAULT_SCRIPT: 'AUTO_ADD_DEFAULT_SCRIPT',
    DEFAULT_SCRIPT_UPDATED: 'DEFAULT_SCRIPT_UPDATED',
    SCRIPT_IS_A_DEFAULT: 'SCRIPT_IS_A_DEFAULT',
    EDIT_SCRIPT: 'EDIT_SCRIPT',
    ARCHIVE_SCRIPT: 'ARCHIVE_SCRIPT',
    DEFAULT_SCRIPTS_IGNORED_ARCHIVE: 'DEFAULT_SCRIPTS_IGNORED_ARCHIVE',
    UNARCHIVE_SCRIPT: 'UNARCHIVE_SCRIPT',
    DELETE_SCRIPT: 'DELETE_SCRIPT',
    DEFAULT_SCRIPTS_IGNORED_DELETE: 'DEFAULT_SCRIPTS_IGNORED_DELETE',
    ADD_EMAIL: 'ADD_EMAIL',
    AUTO_ADD_DEFAULT_EMAIL: 'AUTO_ADD_DEFAULT_EMAIL',
    DEFAULT_EMAIL_UPDATED: 'DEFAULT_EMAIL_UPDATED',
    EMAIL_IS_A_DEFAULT: 'EMAIL_IS_A_DEFAULT',
    EDIT_EMAIL: 'EDIT_EMAIL',
    ARCHIVE_EMAIL: 'ARCHIVE_EMAIL',
    DEFAULT_EMAILS_IGNORED_ARCHIVE: 'DEFAULT_EMAILS_IGNORED_ARCHIVE',
    DELETE_EMAIL: 'DELETE_EMAIL',
    DEFAULT_EMAILS_IGNORED_DELETE: 'DEFAULT_EMAILS_IGNORED_DELETE',
    UNARCHIVE_EMAIL: 'UNARCHIVE_EMAIL',
    COMMON_CALLER_ID_DELETE: 'COMMON_CALLER_ID_DELETE',
    ROTATION_NUMBER_DELETE: 'ROTATION_NUMBER_DELETE',
    FORWARDING_NUMBER_DELETE: 'FORWARDING_NUMBER_DELETE',
    UNAVAILABLE_ROTATION_NUMBER:
      'NUMBER_WITH_CHOSEN_AREA_CODE_IS_NOT_AVAILABLE',
    COMMON_CALLER_ID_VERIFY: 'COMMON_CALLER_ID_VERIFY',
    DNC_DELETE: 'DNC_DELETE',
    DNC_RESTORE: 'DNC_RESTORE',
    DNC_EDIT: 'DNC_EDIT',
    DNC_ADD: 'DNC_ADD',
    DNC_EXPORT: 'DNC_EXPORT',
    GLOBAL_DNC_DELETE: 'GLOBAL_DNC_DELETE',
    GLOBAL_DNC_RESTORE: 'GLOBAL_DNC_RESTORE',
    GLOBAL_DNC_EDIT: 'GLOBAL_DNC_EDIT',
    GLOBAL_DNC_ADD: 'GLOBAL_DNC_ADD',
    GLOBAL_DNC_EXPORT: 'GLOBAL_DNC_EXPORT',
    ADD_GROUP: 'ADD_GROUP',
    EDIT_GROUP: 'EDIT_GROUP',
    STATE_TSR_DELETE: 'STATE_TSR_DELETE',
    STATE_TSR_ADD: 'STATE_TSR_ADD',
    STATE_TSR_EDIT: 'STATE_TSR_EDIT',
    ACCOUNT_SETTINGS_EDIT: 'ACCOUNT_SETTINGS_EDIT',
    CHECK_CALLER_ID_FILE_FAILED: 'CHECK_CALLER_ID_FILE_FAILED',
    DIAL_IN_NUMBER_PURCHASED: 'DIAL_IN_NUMBER_PURCHASED',
  },
  GLOBAL_SUCCESS_CODES: {
    AUTO_MARK_DEFAULT: 'AUTO_MARK_DEFAULT',
    SWAP_DEFAULT_RESOURCE: 'SWAP_DEFAULT_RESOURCE',
    DEFAULT_RESOURCES_IGNORED: 'DEFAULT_RESOURCES_IGNORED',
  },
  GLOBAL_ERROR_CODES: {
    INVALID_USER_ID: 'INVALID_USER_ID',
    TOKEN_NOT_FOUND: 'TOKEN_NOT_FOUND',
    PARSING_ERROR: 'PARSING_ERROR',
    BAD_REQUEST: 'BAD_REQUEST',
    INVALID_ID: 'INVALID_ID',
    NO_FILE_SELECTED: 'NO_FILE_SELECTED',
    INVALID_TOTAL_FILES_SIZE: 'INVALID_TOTAL_FILES_SIZE',
    USER_PERMISSION_DENIED: 'USER_PERMISSION_DENIED',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    EMAIL_TEMPLATE_ALREADY_EXISTS: 'EMAIL_TEMPLATE_ALREADY_EXISTS',
    DEFAULT_EMAIL_TEMPLATE_ALREADY_EXISTS:
      'DEFAULT_EMAIL_TEMPLATE_ALREADY_EXISTS',
    EMAIL_TEMPLATE_NOT_FOUND: 'EMAIL_TEMPLATE_NOT_FOUND',
    INVALID_INPUT_ID: 'INVALID_INPUT_ID',
    GLOBAL_SCRIPT_ALREADY_EXISTS: 'GLOBAL_SCRIPT_ALREADY_EXISTS',
    GLOBAL_SCRIPT_ALREADY_EXISTS_FOR_GIVEN_TYPE:
      'GLOBAL_SCRIPT_ALREADY_EXISTS_FOR_GIVEN_TYPE',
    SCRIPT_NOT_FOUND: 'SCRIPT_NOT_FOUND',
    SCRIPT_ALREADY_EXISTS: 'SCRIPT_ALREADY_EXISTS',
    DEFAULT_SCRIPT_ALREADY_EXISTS: 'DEFAULT_SCRIPT_ALREADY_EXISTS',
    INVALID_TOKEN: 'INVALID_TOKEN',
    INVALID_FIELD_NAME: 'INVALID_FIELD_NAME',
    INVALID_FILES_COUNT: 'INVALID_FILES_COUNT',
    FETCH_ERROR: 'FETCH_ERROR',
    RESOURCE_IS_A_DEFAULT: 'RESOURCE_IS_A_DEFAULT',
    UNABLE_TO_ADD_NUMBER_TO_SECONDARY_BUSINESS_PROFILE:
      'UNABLE_TO_ADD_NUMBER_TO_SECONDARY_BUSINESS_PROFILE',
    CAN_NOT_FIND_BUSINESS_PROFILE_OR_STIR_SHAKEN_PRODUCT:
      'CAN_NOT_FIND_BUSINESS_PROFILE_OR_STIR_SHAKEN_PRODUCT',
    UNABLE_TO_ADD_NUMBER_TO_STIR_SHAKEN: 'UNABLE_TO_ADD_NUMBER_TO_STIR_SHAKEN',
    COULD_NOT_FIND_SUB_ACCOUNT_FOR_THIS_USER:
      'COULD_NOT_FIND_SUB_ACCOUNT_FOR_THIS_USER',
    UNABLE_TO_ADD_PHONE_TO_STIR_SHAKEN: 'UNABLE_TO_ADD_PHONE_TO_STIR_SHAKEN',
  },
  ALERT_HIDING_TIME: 6000,
  ATTACHMENT: {
    IMAGE: '.png, .jpeg',
    FILE: 'audio/*, video/*, image/*, text/*, .zip, .rar, .7zip, .doc, .docx, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  },
  POLLING_INTERVAL: 2000,
  EXTERNAL_URL: {
    QA: {
      REGISTRATION_URL: 'https://qaregistration.archagent.com',
      TERMS_AND_CONDITION:
        'http://www.archagent.com/service-terms-and-conditions',
      PRIVACY_POLICY: 'http://www.archagent.com/privacy-policy',
      CONSUMER: 'http://www.archagent.com/tcpa',
      DNC_REGISTRY: 'http://www.archagent.com/do_not_call_compliance',
      CCPA: 'http://www.archagent.com/ccpa',
    },
    PROD: {
      REGISTRATION_URL: 'https://registration.archagent.com',
      TERMS_AND_CONDITION:
        'http://www.archagent.com/service-terms-and-conditions',
      PRIVACY_POLICY: 'http://www.archagent.com/privacy-policy',
      CONSUMER: 'http://www.archagent.com/tcpa',
      DNC_REGISTRY: 'http://www.archagent.com/do_not_call_compliance',
      CCPA: 'http://www.archagent.com/ccpa',
    },
  },
  PHONE_NUMBER_INPUT_MASK: '(999) 999-9999',
  SMS_CODE_INPUT_MASK: '99999',
  ENTER_KEY: 'Enter',
  PHONE_NUMBER_DIGITS_COUNT: 10,
  AVAILABLE_SYSTEM_NUMBERS_AMOUNT: 5,
};
